/**
 * Stories handled by ZillowNavbar
 */
/* eslint-disable local-rules/require-storybook-documentation */
import { DetailedIconHome, IconChevronRightOutline, Spacer } from '@zillow/constellation';
import React, { EventHandler, FunctionComponent, SyntheticEvent, useCallback, useMemo } from 'react';
import { HEADER_VERSIONS } from '../../constants';
import { HomeLoansDashboardLinkContainer } from './components/HomeLoansDashboardLinkContainer';
import { HomeLoansDashboardContentContainer } from './components/HomeLoansDashboardContentContainer';
import { HomeLoansDashboardLinkHeader } from './components/HomeLoansDashboardLinkHeader';
import { HomeLoansDashboardLinkParagraph } from './components/HomeLoansDashboardLinkParagraph';
import { HomeLoansDashboardLinkAnchor } from './components/HomeLoansDashboardLinkAnchor';

export type HomeLoansDashboardLinkProps = {
    zhlHost?: string;
    version: HEADER_VERSIONS;
};

export const HomeLoansDashboardLink: FunctionComponent<HomeLoansDashboardLinkProps> = ({
    zhlHost = 'https://zillowhomeloans.com',
    version,
}) => {
    const linkUrl = useMemo(() => new URL('/homeloans/mortgage/dashboard/login', zhlHost), [zhlHost]);

    const handleClick: EventHandler<SyntheticEvent<HTMLButtonElement>> = useCallback(() => {}, []);

    return (
        <HomeLoansDashboardLinkContainer version={version}>
            <HomeLoansDashboardContentContainer version={version}>
                <Spacer marginRight={2}>
                    <DetailedIconHome />
                </Spacer>
                <div>
                    <HomeLoansDashboardLinkHeader as="h6">Started a loan application?</HomeLoansDashboardLinkHeader>
                    <HomeLoansDashboardLinkParagraph>
                        Pick up where you left off on your Zillow Home Loans dashboard.
                    </HomeLoansDashboardLinkParagraph>
                    <HomeLoansDashboardLinkAnchor
                        role="link"
                        // @ts-expect-error
                        forwardedAs="a"
                        href={linkUrl}
                        icon={<IconChevronRightOutline />}
                        iconPosition="end"
                        onClick={handleClick}>
                        Home Loans dashboard
                    </HomeLoansDashboardLinkAnchor>
                </div>
            </HomeLoansDashboardContentContainer>
        </HomeLoansDashboardLinkContainer>
    );
};
